@if (fieldData().readonly) {
    @if (angularJsSupport()) {
        @if (angularJsSupportCellField()) {
            <div>
                <p class="ellipsedText scrollable" style="padding-top: 10px; max-height: 100px; white-space: normal">
                    {{ angularJsViewValue() || "-" }}
                </p>
            </div>
        } @else {
            <div>
                <label class="uneditableFormLabel">{{ fieldData().label }}</label>
                <p class="uneditableFormItem ellipsedText">{{ angularJsViewValue() || "-" }}</p>
            </div>
        }
    } @else {
        <cipo-text-view [config]="fieldData()" [value]="control().value" />
    }
} @else {
    <div class="cipo--width--full">
        @if (!fieldData()?.multiple) {
            <mat-form-field
                class="cipo--width--full"
                [class.multiple-values]="fieldData()?.multiple"
                [class.angularjs-support]="angularJsSupport()"
                [ngClass]="{ 'cipo-input cipo-input--sm p-0': angularJsSupport() }"
                [class.cipo-mark-changed]="valueChanged()"
                [appearance]="angularJsSupport() ? 'fill' : 'outline'">
                @if (fieldData().label) {
                    <mat-label>{{ fieldData().label | translate }}</mat-label>
                }

                @if (autocomplete()) {
                    <mat-autocomplete
                        #addressAutocomplete="matAutocomplete"
                        [displayWith]="getAddressText.bind(this)"
                        (optionSelected)="onAutocompleteOptionSelected($event)">
                        @for (suggestion of addressSuggestions$ | async; track $index) {
                            <mat-option [value]="suggestion">{{ getAddressText(suggestion) }}</mat-option>
                        }
                    </mat-autocomplete>
                    <input
                        matInput
                        data-testid="cipo-address-autocomplete-input"
                        [formControl]="autocompleteSearchControl"
                        [matAutocomplete]="addressAutocomplete"
                        [placeholder]="fieldData().placeholder ?? '' | translate" />
                } @else {
                    <input
                        matInput
                        readonly
                        data-testid="cipo-address-input"
                        class="cipo--cursor--pointer"
                        [formControl]="displaySingleValueControl()"
                        [placeholder]="fieldData().placeholder ?? '' | translate"
                        (click)="open($event)" />
                }

                @if (fieldData().prefixIcon) {
                    <mat-icon matPrefix>{{ fieldData().prefixIcon }}</mat-icon>
                }
                @if (fieldData().prefix) {
                    <span matTextPrefix>{{ fieldData().prefix | translate }}</span>
                }

                @if (fieldData().suffixIcon) {
                    <mat-icon matSuffix>{{ fieldData().suffixIcon }}</mat-icon>
                }
                @if (fieldData().suffix) {
                    <span matTextSuffix>{{ fieldData().suffix | translate }}</span>
                }

                @if (canClearInput() && control().value && !control().disabled) {
                    <button matSuffix mat-icon-button data-testid="cipo-address-input-clear"
                            [attr.aria-label]="'a11y.form.clearInput' | translate"
                            (click)="deleteAddress()">
                        <mat-icon aria-hidden="true">close</mat-icon>
                    </button>
                } @else if (fieldData().fieldDescription) {
                    <mat-icon matSuffix
                              data-testid="cipo-address-input-info"
                              class="material-icons-outlined cipo--cursor--help"
                              [title]="fieldData().fieldDescription | translate">
                        info
                    </mat-icon>
                }

                @if (!autocomplete() || addresses().length > 0) {
                    <button mat-icon-button matSuffix data-testid="cipo-address-action-location"
                            [attr.aria-label]="'a11y.form.editLocation' | translate"
                            (click)="open($event)">
                        <mat-icon aria-hidden="true">edit_location</mat-icon>
                    </button>
                }

                @if (control().invalid && control().touched) {
                    <mat-error>
                        {{ control().hasError("custom") ? control().errors.custom : ("errors.required" | translate) }}
                    </mat-error>
                }

                @if (fieldData().hint) {
                    <mat-hint>{{ fieldData().hint | translate }}</mat-hint>
                }
            </mat-form-field>
        } @else {
            <mat-form-field
                class="cipo--width--full"
                [class.multiple-values]="fieldData()?.multiple"
                [class.angularjs-support]="angularJsSupport()"
                [class.cipo-mark-changed]="valueChanged()"
                [ngClass]="{ 'cipo-input cipo-input--sm p-0': angularJsSupport() }"
                [appearance]="angularJsSupport() ? 'fill' : 'outline'">
                @if (fieldData().label) {
                    <mat-label>{{ fieldData().label | translate }}</mat-label>
                }

                @if (autocomplete()) {
                    <mat-autocomplete
                        #addressAutocompleteMultiple="matAutocomplete"
                        [displayWith]="getAddressText.bind(this)"
                        (optionSelected)="onAutocompleteOptionSelected($event, multipleAutocompleteInput)">
                        @for (suggestion of addressSuggestions$ | async; track $index) {
                            <mat-option [value]="suggestion">{{ getAddressText(suggestion) }}</mat-option>
                        }
                    </mat-autocomplete>
                    <mat-chip-grid #autocompleteChipGrid [formControl]="control()">
                        @for (address of addresses(); track $index) {
                            <mat-chip-row
                                data-testid="cipo-address-autocomplete-chip"
                                [value]="address"
                                [editable]="false"
                                (removed)="removeAutocompleteAddress($index)"
                                (click)="open($event)">
                                {{ addressService.formatAddress(address, fieldData()?.displayType) }}
                                @if (!control().disabled) {
                                    <button matChipRemove data-testid="cipo-address-autocomplete-chip-remove"
                                            [attr.aria-label]="'a11y.form.removeChip' | translate: { value: addressService.formatAddress(address, fieldData()?.displayType) }">
                                        <mat-icon aria-hidden="true">cancel</mat-icon>
                                    </button>
                                }
                            </mat-chip-row>
                        }
                        <input
                            #multipleAutocompleteInput
                            data-testid="cipo-address-autocomplete-multiple-input"
                            [formControl]="autocompleteSearchControl"
                            [matAutocomplete]="addressAutocompleteMultiple"
                            [matChipInputFor]="autocompleteChipGrid"
                            [placeholder]="fieldData().placeholder ?? '' | translate" />
                    </mat-chip-grid>
                } @else {
                    <mat-chip-grid #chipGrid [formControl]="control()">
                        @for (address of addresses(); track $index) {
                            <mat-chip-row
                                data-testid="cipo-address-chip"
                                [value]="address"
                                [editable]="false"
                                (click)="open($event)">
                                {{ addressService.formatAddress(address, fieldData()?.displayType) }}
                            </mat-chip-row>
                        }
                        <input
                            readonly
                            class="cipo--cursor--pointer"
                            data-testid="cipo-address-input"
                            [matChipInputFor]="chipGrid"
                            (click)="open($event)" />
                    </mat-chip-grid>
                }

                @if (!autocomplete() || addresses().length > 0) {
                    <button mat-icon-button matSuffix data-testid="cipo-address-action-location"
                            [attr.aria-label]="'a11y.form.editLocation' | translate"
                            (click)="open($event)">
                        <mat-icon aria-hidden="true">edit_location</mat-icon>
                    </button>
                }

                @if (control().invalid && control().touched) {
                    <mat-error>
                        {{ control().hasError("custom") ? control().errors.custom : ("errors.required" | translate) }}
                    </mat-error>
                }

                @if (fieldData().hint) {
                    <mat-hint>{{ fieldData().hint | translate }}</mat-hint>
                }
            </mat-form-field>
        }
    </div>
}
